// extracted by mini-css-extract-plugin
module.exports = {"close":"close-component_close__Zl7nU"};